// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__vZpnn","actionsCol":"EnrolledClinics_actionsCol__26vEU"};